/**
 * Focus Trap
 *
 * Für jedes Element mit der Klasse "wcag-focus-trap" wird ein Focus Trap
 * über die npm-Bibliothek "focus-trap" initialisiert (zentraler Ansatz im Theme).
 *
 * Jedes UX-Element mit .wcag-focus-trap muss sicherstellen, dass
 * - es mit ESC geschlossen werden kann (focus-trap macht das standardmäßig)
 * - der "Close"-Button Teil des Focus-Trap-Elements ist
 *
 * @author jjarolim
 */

import { createFocusTrap } from 'focus-trap';

const init = () => {
    const focusTrapElements = document.querySelectorAll('.wcag-focus-trap');

    focusTrapElements.forEach((element) => {
        const trap = createFocusTrap(element, {
            escapeDeactivates: true,
            returnFocusOnDeactivate: true,
            allowOutsideClick: true,
        });
        trap.activate();
    });
};

export { init };
